import {MouseEvent} from 'react';
import {useParams} from 'react-router-dom';
import cn from 'classnames';

import {openLandingUrl} from '@zzng/common/utils/openLandingUrl';

import InnerHTMLRenderer from '@/shared/components/InnerHTMLRenderer';
import {TIARA_DETAIL_ACTION, TIARA_DETAIL_PAGE_NAME} from '@/shared/constants/tiara';
import useTiara from '@/shared/hooks/useTiara';

type Props = {
  className?: string;
  descriptions: string[];
};

const CardInfoFooter = ({className, descriptions}: Props) => {
  const {trackEvent} = useTiara({pageName: TIARA_DETAIL_PAGE_NAME.CARD_INFO});
  const {groupCode = ''} = useParams<{groupCode: string}>();

  if (descriptions.length === 0) {
    return null;
  }

  return (
    <div className={cn('group_list type_dot', className)}>
      <ul className="list_g" role="list">
        {descriptions.map((description) => (
          <li role="listitem" key={description}>
            <div className="item_list" role="text">
              <span className="dot_item"></span>
              <InnerHTMLRenderer
                className="cont_item"
                html={description}
                selectorProps={{
                  a: {
                    class: 'link_g',
                    onClick: (e: MouseEvent<HTMLAnchorElement>) => {
                      openLandingUrl(e.currentTarget.href);
                      e.preventDefault();
                      trackEvent({
                        action: TIARA_DETAIL_ACTION.CARD_DISCRIPTION_LINK_CLICK,
                        customProps: {link_name: e.currentTarget.text, group_code: groupCode}
                      });
                    }
                  }
                }}
              />
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default CardInfoFooter;
